import { render, staticRenderFns } from "./IBMlibros.vue?vue&type=template&id=d33aaf3c&scoped=true&"
import script from "./IBMlibros.vue?vue&type=script&lang=js&"
export * from "./IBMlibros.vue?vue&type=script&lang=js&"
import style0 from "./IBMlibros.vue?vue&type=style&index=0&id=d33aaf3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33aaf3c",
  null
  
)

export default component.exports